export const imgRender = (files: any, imgUrl: any) => {
    const file = files[0];
    // FileReader 객체 : 웹 애플리케이션이 데이터를 읽고, 저장하게 해줌
    const reader = new FileReader();

    // load 이벤트 핸들러. 리소스 로딩이 완료되면 실행됨.
    reader.onload = (ee: any) => {
        imgUrl = ee.target.result;
    }; // ref previewImage 값 변경

    // 컨텐츠를 특정 file에서 읽어옴. 읽는 행위가 종료되면 loadend 이벤트 트리거함
    // & base64 인코딩된 스트링 데이터가 result 속성에 담김
    reader.readAsDataURL(file);
};
export const dateFormat = (selectDate: number | string | Date) => {
    let date: Date;
    if (typeof selectDate === "string") {
        const year = parseInt(selectDate.substring(0, 4), 10);
        const month = parseInt(selectDate.substring(4, 6), 10) - 1;
        const day = parseInt(selectDate.substring(6, 8), 10);

        date = new Date(year, month, day);
    } else if (typeof selectDate === "number") {
        const dateString = selectDate.toString();
        const year = parseInt(dateString.substring(0, 4), 10);
        const month = parseInt(dateString.substring(4, 6), 10) - 1;
        const day = parseInt(dateString.substring(6, 8), 10);

        date = new Date(year, month, day);
    } else {
        date = selectDate;
    }
    const formattedYear: number = date.getFullYear();
    let formattedMonth: number | string = date.getMonth() + 1;
    formattedMonth = formattedMonth < 10 ? "0" + formattedMonth : formattedMonth.toString();
    let formattedDay: number | string = date.getDate();
    formattedDay = formattedDay < 10 ? "0" + formattedDay : formattedDay.toString();

    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
};
export const formatDate = (isoDateString: string): string => {
    const date = new Date(isoDateString);

    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);

    const formattedDateString = `${year}.${month}.${day} ${hours}:${minutes}`;

    return formattedDateString;
}

export const floatFormat = (num: any): number => {
    if (typeof num !== "number") {
        num = parseFloat(num);
    }
    const formattedNum = num.toFixed(1);

    return formattedNum.endsWith(".0") ? parseInt(formattedNum, 10) : formattedNum;
};

export const numberFormat = (number: number | string) => {
    let formatNum = number.toString();
    return formatNum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const phoneFormat = (phone: number | string) => {
    let phoneStr = phone.toString();

    phoneStr = phoneStr.replace(/\D/g, "");

    if (phoneStr.length === 10) {
        return `${phoneStr.substring(0, 2)}-${phoneStr.substring(2, 6)}-${phoneStr.substring(6)}`;
    } else {
        return `${phoneStr.substring(0, 3)}-${phoneStr.substring(3, 7)}-${phoneStr.substring(7)}`;
    }
};

export const sortListDate = (data: any, type:string='down') => {
    data.sort((a: any, b: any) => {
        a.date = a.updateDate || a.createDate;
        b.date = b.updateDate || b.createDate;
        if (type === 'down') {
            return new Date(b.date).getTime() - new Date(a.date).getTime();
        }else if(type === 'up'){
            return new Date(a.date).getTime() - new Date(b.date).getTime();
        }else{
            return new Date(b.date).getTime() - new Date(a.date).getTime();
        }
    });
};